"use strict";

var _login = require("./login");
/**
 * Template: Loyalty Login
 * ------------------------------------------------------------------------------
 * A file that imports login page logic for loyalty login template
 *
 * @namespace loyalty.login
 */


(0, _login.login)().init();